import { Component, OnInit, OnDestroy } from '@angular/core';
import { LoginAwareComponent } from '../../../../login-aware-component';
import { DiagnosticsServiceFactory } from '../../../../services/diagnostics-service-factory';
import { BroadcastService, MsalService } from '@azure/msal-angular';
import { SalesApiService } from '../../services/sales-api.service';
import { PanelScrollingService } from '../../services/panel-scrolling.service';

/**
 *
 * */
@Component({
  selector: 'campfire-login-panel',
  templateUrl: './login-panel.component.html',
  styleUrls: ['./login-panel.component.scss']
})
export class LoginPanelComponent extends LoginAwareComponent implements OnInit, OnDestroy {
  kpiOverview: any = null;

  salesDetailsVisible: boolean = false;

  constructor(
    diagnosticsFactory: DiagnosticsServiceFactory,
    broadcastService: BroadcastService,
    authService: MsalService,
    private salesApi: SalesApiService,
    private panelScrolling: PanelScrollingService) {
    super(diagnosticsFactory.create('LoginComponent'), broadcastService, authService);
  }

  ngOnInit() {
    super.ngOnInit();

    this.salesApi.getOverview().subscribe(o => this.kpiOverview = o);
  }

  protected onLoginFailure(payload: any) {
    this.handleLoginFailure(payload);
  }

  public login() {
    this.authService.loginPopup();
  }

  public logout() {
    this.authService.logout();
  }

  showLobDetails(item: string): void {
    this.salesDetailsVisible = !this.salesDetailsVisible;
    this.panelScrolling.toggleSalesDetails(this.salesDetailsVisible);
  }
}

